define(['jquery', 'jquery-ui/jquery-ui'], function($) {
    (function($) {
        $.fn.sliderAction = function(options) {
            options = $.extend(
                {
                    timing: 500
                },
                options
            );

            var listContainer = this,
                listParent = $(options.listParent),
                listClass = options.listClass,
                next = $(options.next),
                prev = $(options.prev),
                timing = options.timing;

            var slider = {
                listContainer: listContainer,
                $listParent: listParent,
                list: listParent.find(listClass),
                next: next,
                prev: prev,
                timing: timing,
                position: 0,
                step: 0,
                listLength: 0,
                disableArrows: false,
                visibleContainerWidth: 0,
                moving: false,

                init: function() {
                    slider.next.on('click', slider.nextSlide);
                    slider.prev.on('click', slider.prevSlide);

                    slider.update();

                    slider.listContainer.draggable({
                        axis: 'x',
                        drag: function(event, ui) {
                            var maxLeft = -slider.list.length * slider.step + slider.visibleContainerWidth;
                            if (ui.position.left > maxLeft) {
                                ui.position.left = Math.min(0, ui.position.left);
                            } else {
                                ui.position.left = maxLeft;
                            }
                        },
                        stop: function(event, ui) {
                            slider.position = Math.round(-ui.position.left / slider.step);
                            slider.checkDisabled();
                        }
                    });

                    return slider;
                },

                updateStep: function() {
                    if (slider.list.length === 0) {
                        slider.step = 0;

                        return;
                    }

                    var $itemEl = $(slider.list[0]);

                    slider.step =
                        slider.step || $itemEl.outerWidth() + parseInt($itemEl.css('margin-left')) + parseInt($itemEl.css('margin-right'));
                },

                nextSlide: function() {
                    if (slider.next.hasClass('disabled')) {
                        return false;
                    }
                    if (slider.moving === true) {
                        return false;
                    }

                    slider.moving = true;

                    // is something still hidden?
                    var currentLeft = -parseInt(slider.listContainer.css('left')) || 0;
                    var hiddenPx = slider.list.length * slider.step - slider.visibleContainerWidth - currentLeft;
                    if (hiddenPx > 0) {
                        slider.position++;
                        var additionalMargin = parseInt($(slider.list[slider.position]).css('margin-left'));
                        if (additionalMargin > 0) {
                            additionalMargin = 0;
                        }
                        var move = -slider.position * slider.step - additionalMargin * slider.position;
                        if (hiddenPx < slider.step) {
                            move = -currentLeft - hiddenPx;
                        }
                        slider.listContainer.animate(
                            {
                                left: move
                            },
                            slider.timing,
                            function() {
                                slider.checkDisabled();
                                slider.moving = false;
                            }
                        );
                    } else {
                        slider.checkDisabled();
                        slider.moving = false;
                    }
                },

                prevSlide: function() {
                    if (slider.prev.hasClass('disabled')) {
                        return false;
                    }
                    if (slider.moving === true) {
                        return false;
                    }

                    slider.moving = true;

                    if (slider.position > 0) {
                        slider.position--;

                        var additionalMargin = parseInt($(slider.list[slider.position]).css('margin-left'));
                        if (additionalMargin > 0) {
                            additionalMargin = 0;
                        }
                        var move = -slider.position * slider.step - additionalMargin * slider.position;
                        slider.listContainer.animate(
                            {
                                left: move
                            },
                            slider.timing,
                            function() {
                                slider.checkDisabled();
                                slider.moving = false;
                            }
                        );
                    } else {
                        slider.checkDisabled();
                        slider.moving = false;
                    }
                },

                checkDisabled: function() {
                    if (slider.position === 0) {
                        slider.prev.addClass('disabled');
                    } else {
                        slider.prev.removeClass('disabled');
                    }

                    var currentLeft = -parseInt(slider.listContainer.css('left')) || 0;
                    if (slider.list.length * slider.step - slider.visibleContainerWidth - currentLeft <= 0) {
                        slider.next.addClass('disabled');
                    } else {
                        slider.next.removeClass('disabled');
                    }
                },

                update: function() {
                    slider.updateStep();
                    slider.visibleContainerWidth = slider.$listParent.outerWidth();
                    slider.list = listParent.find(listClass);
                    slider.listLength = slider.list.length * slider.step;
                    slider.disableArrows = slider.visibleContainerWidth >= slider.list.length * slider.step;

                    if (slider.listLength) {
                        slider.listContainer.width(slider.listLength);
                    }

                    if (slider.disableArrows === false) {
                        slider.prev.show();
                        slider.next.show();
                    } else {
                        slider.prev.hide();
                        slider.next.hide();
                        slider.listContainer.css('left', '0');
                    }
                    slider.checkDisabled();
                },

                reset: function() {
                    slider.position = 0;
                    slider.listContainer.css('left', '0');
                },

                unbind: function() {
                    slider.next.off('click');
                    slider.prev.off('click');
                }
            };

            $.fn.sliderAction.update = slider.update;

            $.fn.sliderAction.reset = slider.reset;

            $.fn.sliderAction.destroy = function() {
                slider.unbind();
                slider.listContainer.css('left', '0');
            };

            slider.init();
        };
    })($);
});
